import axios from "axios";
import { api } from "./helper";
import store from "../../store/store"
import { v4 as uuidv4 } from "uuid";

function prepareDataRequest(data) {
  return { RequestCorrelationId: uuidv4(), Data: data };
}
function prepareRequest(data) {
  return { ...data, RequestCorrelationId: uuidv4() };
}

const client = axios.create({
    baseURL: api,
    withCredentials: false,
});

client.interceptors.request.use((config) => {
    config.headers.Authorization = "Bearer " + store.state.user.jwt;
    return config;
});

function UploadFile(formData) {
    const requestCorrelationId = crypto.randomUUID();
    return client.post(`Upload/${requestCorrelationId}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

function Create(file) {
  return client.post("Files/CreateFileData", prepareDataRequest(file));
}

async function GetFiles(sourcetype, sourceId, sourcedetId, uid) {
    const params = {
        sourcetype: sourcetype,
        sourceId: sourceId,
        sourcedetId: sourcedetId,
        commandUserId: uid
    };

    try {
        const response = await client.post("Files/GetFiles", prepareRequest(params));
        return response.data;
    } catch (error) {
        console.error("Error fetching files:", error);
        throw new Error(error.response?.data?.message || 'An error occurred.');
    }
}

function Delete(id, uid) {
    var item = {
        id: id,
        commandUserId: uid
    };
    return client.post("Files/DeleteFileData", prepareDataRequest(item));
}

export { Create, GetFiles, Delete, UploadFile };

